import React from 'react';
import { useTranslation } from 'react-i18next';
import CommunityHero from '../components/community/CommunityHero';
import CommunitySearch from '../components/community/CommunitySearch';
import CommunityResources from '../components/community/CommunityResources';
import Nav from '../components/Nav'; // Reusing Nav if possible or custom header
import './Community.css';

const Community = () => {
    const { t } = useTranslation();

    return (
        <div className="community-page">
            <header className="community-header">
                <Nav />
            </header>

            <main>
                <CommunityHero />
                <CommunitySearch />
                <CommunityResources />
            </main>

            <footer className="footer">
                <div className="container">
                    <div className="footer-content">
                        <div className="footer-section">
                            <div className="footer-logo">
                                <span style={{ color: '#FF6600' }}>Eco</span><span style={{ color: '#ffffff' }}>ScienceInnova</span>
                            </div>
                            <p>{t('footerText')}</p>
                        </div>
                        <div className="footer-section">
                            <h3>{t('platform')}</h3>
                            <ul>
                                <li>{t('studies')}</li>
                                <li>{t('howItWorks')}</li>
                                <li>{t('dataSecurity')}</li>
                            </ul>
                        </div>
                        <div className="footer-section">
                            <h3>{t('company')}</h3>
                            <ul>
                                <li>{t('aboutUs')}</li>
                                <li>Blog</li>
                                <li>{t('press')}</li>
                            </ul>
                        </div>
                        <div className="footer-section">
                            <h3>{t('legal')}</h3>
                            <ul>
                                <li>{t('termsOfService')}</li>
                                <li>{t('privacyPolicy')}</li>
                                <li>{t('ethicsCode')}</li>
                            </ul>
                        </div>
                    </div>
                    <div className="footer-bottom">
                        <p>&copy; 2024 EcoScienceInnova. {t('allRightsReserved')}</p>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Community;
